
import { BFormInput } from "bootstrap-vue"
import { Component, Vue, Prop, Ref } from "vue-property-decorator"

@Component({
	components: {
	}
})
export default class TimeDurationPicker extends Vue {
	@Ref() hoursInput!: BFormInput
	@Ref() minutesInput!: BFormInput

	@Prop()
	value!: number | null

	@Prop({ default: false })
	readonly!: boolean

	@Prop({ default: "md" })
	size!: "md" | "sm"

	@Prop({ default: true })
	convertMinutesToHours!: boolean

	get currentValue (): number {
		return this.value || 0
	}

	get hours (): number {
		return Math.trunc(this.currentValue)
	}
	set hours (value: number) {
		if (!value) value = 0 // Handle any null values that might slip in
		let hours = Math.trunc(value)
		if (isNaN(hours) || hours < 0) hours = 0 // Check for accidental non-numeric value

		const minuteDecimal = this.value ? this.value % 1 : 0

		this.$emit("input", hours + minuteDecimal)
	}

	get minutes (): number {
		return Math.round((this.currentValue % 1) * 60)
	}
	set minutes (value: number) {
		if (!value) value = 0 // Handle any null values that might slip in
		let minutes = parseInt(value.toString())
		if (isNaN(minutes) || minutes < 0) minutes = 0 // Check for accidental non-numeric value

		let extraHours = 0
		if (this.convertMinutesToHours) {
			while (minutes >= 60) {
				minutes = minutes - 60
				extraHours++
			}
		} else if (minutes >= 60) {
			minutes = 0
		}

		const minuteDecimal = parseFloat((minutes / 60).toFixed(4))

		this.$emit("input", this.hours + extraHours + minuteDecimal)
	}

	mounted () {
		if (this.value === undefined || this.value === null) {
			this.$emit("input", 0)
		}
	}

	focusOut (event: FocusEvent) {
		// Ensure that this event isn't triggered when changing between children, eg clicking between hours and minutes
		if (!event.relatedTarget || !this.$el.contains(event.relatedTarget as any)) {
			this.$emit("blur")
		}
	}

	/**
	 * Forces an update of the component's numeric input fields. This is a workaround for a reactivity
	 * issue in the Bootstrap Input's v-model binding.
	 */
	public forceUpdate () {
		// set the numeric input values to match the current values
		this.hoursInput.localValue = this.hours.toString()
		this.minutesInput.localValue = this.minutes.toString()
		this.hoursInput.$forceUpdate()
		this.minutesInput.$forceUpdate()
	}
}

